import { State } from "../types/store";

export const selectLayout = (state: State) => state.layout;
export const selectLayoutList = (state: State) => state.layout.list;
export const selectLayoutEdited = (state: State) => state.layout.edited;
